import { render, staticRenderFns } from "./LeaderDetail.vue?vue&type=template&id=d57b7958&scoped=true&"
import script from "./LeaderDetail.vue?vue&type=script&lang=js&"
export * from "./LeaderDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeaderDetail.vue?vue&type=style&index=0&id=d57b7958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57b7958",
  null
  
)

export default component.exports